export default __webpack_public_path__ + "static/media/Union 15.dbff885b.svg";